<script setup>
   import { ref, watch, watchEffect, reactive, inject } from 'vue'
   import { useRoute } from 'vue-router'
   import { modalHide } from '@/composables/bootstrap'

   const route = useRoute()

   const $storeCollections = inject('$storeCollections')

   const props = defineProps({
      action: {
         type: String,
         required: true
      },
      collection: {
         type: Object,
         required: true
      }
   })

   const forbiddenCharacters = ['/', '\\', '|', ':', '*', '?', '"', '<', '>', '!']
   const fileNameError = ref(false)
   const validateFileName = string => {
      fileNameError.value = forbiddenCharacters.some(character => string.includes(character))
   }


   const form = reactive({
      collection_id: null,
      name: '',
   })

   watchEffect(() => {
      form.collection_id = parseInt(props.collection?.id)
      form.name = props.collection?.name
   })

   /**
      * Function: submit
      * @description The user has saved the collection.
      * Sends the data to the API.
   */
   const submit = () => {
      if(fileNameError.value || ! form.name) return

      $storeCollections.edit(form)
      modalHide('edit-collection')
   }
</script>

<template>
   <Modal v-if="action == 'edit-collection'" id="edit-collection" size="medium">
      <template #header>Edit Collection</template>
      <template #body>
         <div class="cg-column-content">
            <form @submit.prevent="submit()" class="cg-column-content">
               <div>
                  <label for="collection-name" class="form-label label-required">Collection Name</label>
                  <input id="collection-name" type="text" class="form-control" v-model="form.name" placeholder="Collection Name" :class="{ 'is-valid': form.name && ! fileNameError, 'is-invalid': ! form.name || fileNameError }" @input="validateFileName(form.name)" required>
                  <div v-if="fileNameError" class="text-danger mt-3">File names can't contain special characters.</div>
               </div>

               <div class="d-flex justify-content-end">
                  <PrimaryButton :disabled="! form.name">
                     <template #label>Save Collection</template>
                  </PrimaryButton>
               </div>
            </form>
         </div>
      </template>
   </Modal>
</template>